import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Typography from '@material-ui/core/Typography';
import MailIcon from '@material-ui/icons/Mail';
import DeleteIcon from '@material-ui/icons/Delete';
import Label from '@material-ui/icons/Label';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import InfoIcon from '@material-ui/icons/Info';
import ForumIcon from '@material-ui/icons/Forum';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Play from '@material-ui/icons/PlayArrow'
import Menu from '@material-ui/icons/Menu'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import library from './Icons';
import 'react-sortable-tree/style.css';
import { Formik, Field, Form } from 'formik';
import SortableTree from 'react-sortable-tree';
import Fade from 'react-bootstrap/Fade'
import { ToastContainer, toast } from 'react-toastify';
import * as Yup from 'yup';
import { SaveMenu, GetMenu } from "./Requests";

var lodashArray = require('lodash/array');

export default class Tree extends Component {
    constructor(props) {
        super(props);

        this.state = {
            treeData: [],
            selectedItem: null,
            showForm: false,
            addChild: false,
            formData: {
                menuIcon: '',
                parentLabel: '',
                menuLabel: '',
                videoTitle: '',
                videoUrl: '',
                videoDescription: '',
                videoSteps: ''
            },
            loading: false
        };

        this.structureMenu = this.structureMenu.bind(this);
    }

    componentDidMount() {
        GetMenu()
            .then(response => {
                if (response.status === 200) {
                    this.setState({ treeData: response.data });
                } else {
                    toast.dark(response.message);
                }
            })
    }

    saveMenu = async (data) => {
        let response = await SaveMenu(data)

        if (response.status === 200) {
            //this.setState({ JWTToken: response.data }, () => { sessionStorage.setItem("JWTToken", this.state.JWTToken); toast.dark(response.message) })
            toast.dark(response.message);
            this.props.setMenu(Array.isArray(response.data) ? response.data : [response.data])
        } else {
            toast.dark(response.message);
        }

        /*SaveMenu(data)
                    .then(response => {
                        if (response.status === 200) {
                            //this.setState({ JWTToken: response.data }, () => { sessionStorage.setItem("JWTToken", this.state.JWTToken); toast.dark(response.message) })
                            toast.dark(response.message);
                        } else {
                            toast.dark(response.message);
                        }
                    })*/
    }

    structureMenu = (treeData) => {
        if (Array.isArray(treeData)) {
            treeData.forEach((node, index) => {
                node.order = (index + 1);
                if (node.children) {
                    if (node.children.length > 0 || !node.video || node.video?.url === "") {
                        delete node["video"];
                    }

                    if (node.children.length > 0) {
                        this.structureMenu(node);
                    }
                }
            })
        } else {
            if (treeData.children) {
                treeData.children.forEach((node, index) => {
                    node.order = (index + 1);
                    if (node.children) {
                        if (node.children.length > 0 || !node.video || node.video?.url === "") {
                            delete node["video"];
                        }

                        if (node.children.length > 0) {
                            this.structureMenu(node);
                        }
                    }
                })
            }
        }

        return treeData;
    }

    handleButtonAction = (e, button, values = null, resetForm = null) => {
        switch (button) {
            case "Nuevo":
                e.preventDefault();
                this.setState({ showForm: true, selectedItem: null, addChild: false, formData: this.getCleanForm() });
                break;
            case "Cancelar":
                e.preventDefault();
                this.setState({ showForm: false, selectedItem: null, addChild: false, formData: this.getCleanForm() });
                break;
            case "Agregar Nivel":
                e.preventDefault();
                if (values.menuLabel.length > 0) {
                    if (this.formToNode(values)) {
                        let treeDataCp = Object.assign([], this.state.treeData);
                        treeDataCp.push(this.formToNode(values));
                        this.setState({ treeData: treeDataCp, formData: this.getCleanForm() });
                        resetForm();
                    } else {
                        toast.dark("Debe llenar los campos requeridos");
                    }
                } else {
                    toast.dark("El campo Título de Opción no puede estar vacío");
                }
                break;
            case "Agregar Hijo":
                e.preventDefault();
                if (values.menuLabel.length > 0) {
                    if (this.formToNode(values)) {
                        let tree = this.addTreeNodeChild(Object.assign([], this.state.treeData), this.state.selectedItem, this.formToNode(values));
                        this.setState({ showForm: true, addChild: true, treeData: tree });
                        resetForm();
                    } else {
                        toast.dark("Debe llenar los campos requeridos");
                    }
                } else {
                    toast.dark("El campo Título de Opción no puede estar vacío");
                }
                break;
            case "Editar":
                e.preventDefault();
                if (this.formToNode(values)) {
                    let editTree = this.editTreeNode(Object.assign([], this.state.treeData), this.state.selectedItem, this.formToNode(values));
                    this.setState({ showForm: true, addChild: true, treeData: editTree, selectedItem: null, formData: this.getCleanForm() });
                    resetForm();
                } else {
                    toast.dark("Debe llenar los campos requeridos");
                }
                break;
            case "Eliminar":
                e.preventDefault();
                let newTreeData = this.removeTreeNode(Object.assign([], this.state.treeData), Object.assign({}, this.state.selectedItem));
                this.setState({ treeData: newTreeData, formData: this.getCleanForm(), selectedItem: null, addChild: false });
                break;
            default:
                toast.dark("No se encontró acción para el botón presionado.");
                break;
        }
    }

    removeTreeNode = (treeData, selectedItem) => {
        treeData = lodashArray.remove(treeData, (e) => (JSON.stringify(e) !== JSON.stringify(selectedItem)));

        treeData.forEach(treeNode => {
            if (treeNode.children) {
                treeNode.children = this.removeTreeNode(treeNode.children, selectedItem);
            }
        })

        return treeData;
    }

    addTreeNodeChild = (tree, selectedItem, newChild) => {
        if (Array.isArray(tree)) {
            tree.forEach((node, index) => {
                if (JSON.stringify(node) === JSON.stringify(selectedItem)) {
                    node.expanded = true;
                    if (node.children) {
                        node.children.push(newChild);
                    } else {
                        node.children = [newChild];
                    }
                } else {
                    if (node.children) {
                        this.addTreeNodeChild(node.children, selectedItem, newChild);
                    }
                }
            })
        } else {
            if (JSON.stringify(tree) === JSON.stringify(selectedItem)) {
                tree.expanded = true;
                if (tree.children) {
                    tree.children.push(newChild);
                } else {
                    tree.children = [newChild];
                }
            } else {
                if (tree.children) {
                    this.addTreeNodeChild(tree.children, selectedItem, newChild);
                }
            }
        }

        console.log(JSON.stringify(tree));

        return tree;
    }

    editTreeNode = (tree, selectedItem, newChild) => {
        if (Array.isArray(tree)) {
            tree.forEach((node, index, arr) => {
                if (JSON.stringify(node) === JSON.stringify(selectedItem)) {
                    arr[index] = newChild;
                    arr[index].children = node.children;
                } else {
                    if (node.children) {
                        this.editTreeNode(node.children, selectedItem, newChild);
                    }
                }
            })
        } else {
            if (JSON.stringify(tree) === JSON.stringify(selectedItem)) {
                tree = newChild;
            } else {
                if (tree.children) {
                    this.editTreeNode(tree.children, selectedItem, newChild);
                }
            }
        }

        console.log(JSON.stringify(tree));

        return tree;
    }

    getCleanForm = () => ({
        menuLabel: '',
        videoTitle: '',
        videoUrl: '',
        videoDescription: '',
        videoSteps: ''
    })

    formToNode = (values) => {

        if (!values.menuIcon || values.menuIcon == "") {
            return null
        }

        return {
            id: null,
            title: values.menuLabel,
            icon: values.menuIcon,
            video: {
                title: values.videoTitle,
                url: values.videoUrl,
                description: values.videoDescription,
                steps: values.videoSteps
            },
            expanded: false
        }
    }

    boundResetForm = null

    render() {
        const { treeData, selectedItem, showForm, formData } = this.state;
        return (
            <>
                <Row>
                    <Col className="menu-admin-tree" xs={12} sm={12} md={12} lg={6} xl={6}>
                        <SortableTree
                            treeData={treeData}
                            onChange={e => this.setState({ treeData: e })}
                            generateNodeProps={(node) => {
                                let isNodeSelected = JSON.stringify(node.node) === JSON.stringify(selectedItem);
                                return ({
                                    className: "selectable",
                                    buttons: [
                                        (<button className={"btn btn-" + (isNodeSelected ? "primary" : "secondary")}
                                            onDoubleClick={() => {
                                                if (this.boundResetForm) {
                                                    this.boundResetForm()
                                                }
                                                this.setState({
                                                    formData: {
                                                        menuLabel: node.node.title,
                                                        menuIcon: node.node.icon,
                                                        videoTitle: node.node.video && node.node?.video !== "" ? node.node.video.title : "",
                                                        videoUrl: node.node.video ? node.node.video.url : "",
                                                        videoDescription: node.node.video ? node.node.video.description : "",
                                                        videoSteps: node.node.video ? node.node.video.steps : ""
                                                    }
                                                })
                                            }}
                                            onClick={() => {
                                                this.setState({ selectedItem: node.node, showForm: true })
                                            }
                                            }><FontAwesomeIcon icon={"check-square"} /></button>)
                                    ],
                                    style: isNodeSelected ? { color: "#007bff" } : {}
                                })
                            }
                            }
                        />
                    </Col>
                    <Col className="menu-admin-form">
                        <Formik
                            initialValues={formData}
                            onSubmit={async values => {
                                this.setState({ loading: true }, async () => {
                                    await this.saveMenu(this.structureMenu(Object.assign([], treeData)))

                                    this.setState({ loading: false })
                                })
                            }}
                            enableReinitialize={true}
                        >
                            {({ values, submitForm, resetForm }) => {
                                this.boundResetForm = resetForm; return (
                                    <Form>
                                        <Row className="justify-content-right text-right">
                                            <Col>
                                                <button onClick={!selectedItem && !showForm ? (e) => this.handleButtonAction(e, 'Nuevo') : (e) => this.handleButtonAction(e, 'Cancelar')} className={"mr-2 mb-2 btn btn-secondary"}>{!selectedItem && !showForm ? "Abrir" : "Cerrar"} Formulario</button>
                                                <button type="submit" disabled={this.state.loading} className={"mr-2 mb-2 btn btn-primary"}>{this.state.loading ? <><i className="fa fa-refresh fa-spin" style={{ marginRight: "5px" }} /> Guardando...</> : "Guardar"}</button>
                                                <br />
                                                <button disabled={!showForm} onClick={(e) => { this.handleButtonAction(e, 'Agregar Nivel', values, resetForm); }} className={"mr-2 mb-2 btn btn-" + (!showForm ? "outline-" : "") + "primary"}>Agregar nivel</button>
                                                <button disabled={!selectedItem} onClick={(e) => { this.handleButtonAction(e, 'Agregar Hijo', values, resetForm) }} className={"mr-2 mb-2 btn btn-" + (!selectedItem ? "outline-" : "") + "primary"}>Agregar subnivel</button>
                                                <button onClick={(e) => { this.handleButtonAction(e, 'Editar', values, resetForm) }} disabled={!(showForm && selectedItem && values.menuLabel !== '')} className={"mr-2 mb-2 btn btn-" + (!(showForm && selectedItem && values.menuLabel !== '') ? "outline-" : "") + "info"}>Editar</button>
                                                <button disabled={!(showForm && selectedItem)} onClick={(e) => { this.handleButtonAction(e, 'Eliminar'); resetForm() }} className={"mr-2 mb-2 btn btn-" + (!(showForm && selectedItem) ? "outline-" : "") + "danger"}>Eliminar</button>
                                            </Col>
                                        </Row>
                                        <Fade in={showForm}>
                                            <Row>
                                                <Col md={12} sm={12} xs={12} lg={12}>
                                                    <Row>
                                                        <Col>
                                                            <label htmlFor="menuLabel">Título de Opción: (*)</label>
                                                            <Field className="form-control" id="menuLabel" name="menuLabel" />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col><label>Icono: (*)</label></Col>
                                                    </Row>
                                                    <Row>
                                                        {
                                                            library["definitions"] ?
                                                                Object.keys(library.definitions.fas).map((entry, index) => {
                                                                    return <div className="col-2">
                                                                        <label for={entry} ><FontAwesomeIcon icon={entry} /></label>
                                                                        <Field value={entry} checked={entry == values.menuIcon} type="radio" id={entry} name="menuIcon" />
                                                                    </div>
                                                                })
                                                                :
                                                                ""
                                                        }
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <label htmlFor="videoTitle">Título del Vídeo:</label>
                                                            <Field className="form-control" id="videoTitle" name="videoTitle" />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <label htmlFor="videoUrl">URL del Vídeo:</label>
                                                            <Field className="form-control" id="videoUrl" name="videoUrl" />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <label htmlFor="videoDescription">Descripción del Vídeo:</label>
                                                            <Field className="form-control" rows={5} id="videoDescription" as="textarea" name="videoDescription" />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <label htmlFor="videoSteps">Paso a paso:</label>
                                                            <Field className="form-control" rows={10} id="videoSteps" as="textarea" name="videoSteps" />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Fade>
                                    </Form>
                                )
                            }}
                        </Formik>
                    </Col>
                </Row>
            </>
        );
    }
}